import React from "react";
import { Wrench, Bot, Link2, Zap, PenTool, TrendingUp } from "lucide-react";
import { LABS } from "../mock";

const ICONS = [Wrench, Bot, Link2, Zap, PenTool, TrendingUp];

export default function Laboratori() {
  return (
    <section className="py-24 lg:py-36">
      <div className="container-max">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <span className="section-label">Laboratori pratici mensili</span>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-6 max-w-3xl">
              Imparare<br />
              <span className="italic font-light text-white/60">con la pratica.</span>
            </h2>
            <p className="text-white/60 text-base lg:text-lg mt-6 max-w-2xl leading-relaxed">
              Sessioni tecniche, operative, mensili (live e registrate una a settimana) sui tool più potenti
              presenti sul mercato, che ti permetteranno di realizzare e gestire il tuo marketing.
            </p>
          </div>
          <div className="font-mono-label text-white/40 text-xs">Parola d’ordine — <span className="text-lime">mai soli</span></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {LABS.map((l, i) => {
            const Icon = ICONS[i] || Wrench;
            return (
              <div
                key={i}
                className="bg-card border border-white/10 rounded-2xl p-7 hover-lift group"
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-lime transition-colors">
                    <Icon size={20} className="text-white group-hover:text-black transition-colors" />
                  </div>
                  <span className="font-mono-label text-white/30 text-xs">L0{i + 1}</span>
                </div>
                <div className="font-display text-2xl text-white mb-3">{l.title}</div>
                <p className="text-white/60 text-sm leading-relaxed">{l.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
